<template>
  <div class="service">

    <div class="content">
      <h3 class="title">常见问题</h3>
      <div class="question-box">
        <van-collapse v-model="state.activeNames" :border="false">
          <van-collapse-item title="下载游戏" name="1">
            如果您有需要下载的游戏，可以通过在APP首页的搜索框进行输入游戏名称进行下载
          </van-collapse-item>
          <van-collapse-item title="无法登陆游戏" name="2">
            无法登录有以下几种情况：
            （1）游戏维护，服务器出现异常等都可能导致无法登录，请您耐心等待即可，
            （2）有可能是网络原因或者设备运行不畅导致的，建议您可以稍后尝试“清理手机缓存和游戏数据、重启手机、切换网络（wifi、4g）”再登录一下，
            （3）账号被封，可联系客服为您反馈处理。
          </van-collapse-item>
          <van-collapse-item title="如何折扣充值" name="3">
            目前平台内的折扣是由游戏方进行提供，您可以留意一下APP内游戏专区的折扣显示情况，有显示折扣的游戏可以通过进入游戏点击支付界面进行享受折扣充值。
          </van-collapse-item>
          <van-collapse-item title="游戏下载不了" name="4">
            如果出现游戏无法下载的情况
            （1）您可以通过以下链接进行重装0.1折手游APP进行下载游戏
            （2）如果使用IOS设备，可以点击人工客服联系客服咨询
          </van-collapse-item>
          <van-collapse-item title="游戏角色不见了" name="5">
            游戏角色不见可从以下几个方面检查下： （1）登错帐号、登错服务器；
            （2）安卓和ios系统两者的数据是不互通的
            （3）下载错游戏，平台上该游戏存在多个版本。您当前下载的版本和原来的不一致。
          </van-collapse-item>
          <van-collapse-item title="游戏开服时间" name="6">
            可以在APP首页搜索游戏名，在游戏专区可以查看对应开服表。如APP上没有显示相应开服信息，代表游戏厂商暂未提供最新开服信息，并且开服表仅作参考，游戏厂商可能会有临时变动，实际的开服情况请以游戏内的区服列表或公告为准。
          </van-collapse-item>
          <van-collapse-item title="游戏闪退怎么办" name="7">
            游戏闪退有以下情况， IOS用户： 请您删掉之前的游戏，重新打开APP下载，
            安卓用户： （1）游戏内存不足，关掉多余的后台应用
            （2）游戏异常，请联系在线客服进行反馈
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="kf-box">
        <p>客服服务时间为 09:00-22:00</p>
        <div class="btn" @click="getService()">
          在线客服
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import { getBoxSetting } from "../../api/user";
import { getQueryString } from "../../utils/location";

const router = useRouter();
const state = reactive({
  uid: getQueryString("uid") ? "" : getQueryString("uid"),
  gid: getQueryString("gid") ? "" : getQueryString("gid"),
  user_info: {},
  activeNames: ["1"],
  kefuUrl: "",
});

onMounted(() => {
  //   console.log("七鱼客服页面---------");
  state.gid = getQueryString("gid") ? getQueryString("gid") : state.gid;
  state.uid = getQueryString("uid") ? getQueryString("uid") : state.uid;

    getBoxSetting({
      uid: getQueryString("uid"),
      key: getQueryString("key"),
      token: getQueryString("token"),
      gid: getQueryString("gid"),
    }).then((res) => {
      console.log(res.data.data);
      state.kefuUrl = res.data.data.wxkefuUrl;
    });
});

const getService = () => {
  // configUsr();
  console.log(state.kefuUrl);
  window.location.href = state.kefuUrl;
};
</script>

<style scoped src="../../styles/van-sticky-nav.css"></style>
<style scoped>
.service {
  /* position: fixed; */
  width: 100vw;
  min-height: 100vh;
  background-color: #161B1F;
}
.content {
  background-color: #161B1F;
  padding: 32px;
}
.content .title {
  font-size: 28px;
  color: #12cec7;
  margin-bottom: 28px;
}
.question-box {
  border-radius: 16px;
}

.content .title {
  font-size: 28px;
  color: #12cec7;
  margin-bottom: 28px;
}

.question-box {
  border-radius: 16px;
}

.kf-box {
  /* position: fixed; */
  width: 100%;
  /* bottom: 0; */
  padding: 32px;
  /* left: 0px; */
  margin-top: 100px;
}

.kf-box p {
  font-size: 28px;
  color: #fff;
  text-align: center;
  margin-bottom: 32px;
}

.kf-box .btn {
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 92px;
  background-color: #12cec7;
  color: #fff;
  font-size: 32px;
}
.van-collapse {
  background-color: #1f2430;
  padding: 10px 15px;
}
:deep(.van-cell) {
  background-color: #1f2430;
  color: #fff;
}
:deep(.van-collapse-item__content) {
  background-color: #1f2430;
}
:deep(.van-collapse-item--border:after) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
:deep(.van-cell:after) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
</style>
